// src/app/utilities/validation-constants.ts
export const ValidationConstants = {
    MAX_NAME_LENGTH: 20,
    MAX_EMAIL_LENGTH: 50,
    MAX_DESCRIPTION_LENGTH:50,
    MAX_PASSWORD_LENGTH: 16,
    MIN_PASSWORD_LENGTH: 6,
    MAX_PHONE:16,
    MAX_STATE:12,
    NATIONAL_ID_LENGTH:15,
    SSN_LENGTH:9,
    DRIVING_LISCENSE_PATTERN:'^[A-Za-z]{0,1}[0-9]{7,12}$'
  };
  export const DEFAULTLOGO="assets/images/other-images/defaultLogo.png"
  
  export const DEFAULTITLE="Title"
  
  export enum EmployeeStatusEnum
  {
      Active = 1,
      Terminated = 2,
      OnLeave = 3,
      Inactive = 4,
      All = 5
  }
  export enum LicenseType {
    Demo = 1,
    Standard = 2,
    Enterprise = 3
  }
  
  
  export enum GenderEnum
  {
      Male = 1,
      Female = 2,
     All = 3
  }
  
  export enum EmploymentTypeEnum
  {
      Contractor = 1,
      Employee = 2,
      All = 3
  }
  export enum NationalityEnum
  {
      USNational = 1,
      Other = 2
  }
  
  export enum VisitStatus
  {
      Pending = 1,
      Approved = 2,
      Rejected = 3
  }
  
  
  export enum VisitorStatus
  {
      Pending = 1,
      Approved = 2,
      Rejected = 3
  }
  
  
  export enum DayOfWeek {
    Monday = 1,
    Tuesday=2,
    Wednesday=3,
    Thursday=4,
    Friday=5,
    Saturday=6,
    Sunday=7
  }
  export enum VisitType
  {
      Single = 1,
      Recurring = 2
  }
  
  
  export enum VisitCategory
  {
      WalkIn = 1,
      Scheduled = 2
  }
  
  export enum RecurrenceType
  {
      Daily,
      Weekly,
      Monthly
  }
  export enum BooleanStatus {
    Yes = 'true',
    No = 'false'
}

// Claims
export const CLAIMS = {
  DEPARTMENTS: {
    VIEW: 'DEPARTMENTS_VIEW',
    ADD: 'DEPARTMENTS_ADD',
    DELETE: 'DEPARTMENTS_DELETE',
    UPDATE: 'DEPARTMENTS_UPDATE'
  },
  EMPLOYEES: {
    VIEW: 'EMPLOYEE_VIEW',
    ADD: 'EMPLOYEE_ADD',
    DELETE: 'EMPLOYEE_DELETE',
    UPDATE: 'EMPLOYEE_UPDATE'
  },
  LOCATIONS: {
    VIEW: 'LOCATIONS_VIEW',
    ADD: 'LOCATIONS_ADD',
    DELETE: 'LOCATIONS_DELETE',
    UPDATE: 'LOCATIONS_UPDATE'
  },
  DESIGNATIONS: {
    VIEW: 'DESIGNATIONS_VIEW',
    ADD: 'DESIGNATIONS_ADD',
    DELETE: 'DESIGNATIONS_DELETE',
    UPDATE: 'DESIGNATIONS_UPDATE'
  },
  HOLIDAYS: {
    VIEW: 'HOLIDAYS_VIEW',
    ADD: 'HOLIDAYS_ADD',
    DELETE: 'HOLIDAYS_DELETE',
    UPDATE: 'HOLIDAYS_UPDATE'
  },
  LEAVES: {
    VIEW: 'LEAVES_VIEW',
    ADD: 'LEAVES_ADD',
    DELETE: 'LEAVES_DELETE',
    UPDATE: 'LEAVES_UPDATE',
    APPROVE: 'LEAVES_APPROVE'
  },
  LEAVE_TYPES: {
    VIEW: 'LEAVE_TYPES_VIEW',
    ADD: 'LEAVE_TYPES_ADD',
    DELETE: 'LEAVE_TYPES_DELETE',
    UPDATE: 'LEAVE_TYPES_UPDATE'
  },
  EMPLOYEE_TYPES: {
    VIEW: 'EMPLOYEE_TYPES_VIEW',
    ADD: 'EMPLOYEE_TYPES_ADD',
    DELETE: 'EMPLOYEE_TYPES_DELETE',
    UPDATE: 'EMPLOYEE_TYPES_UPDATE'
  },
  ROLES: {
    VIEW: 'ROLES_VIEW',
    ADD: 'ROLES_ADD',
    DELETE: 'ROLES_DELETE',
    UPDATE: 'ROLES_UPDATE'
  },
  GROUPS: {
    VIEW: 'GROUPS_VIEW',
    ADD: 'GROUPS_ADD',
    DELETE: 'GROUPS_DELETE',
    UPDATE: 'GROUPS_UPDATE'
  },
  PROJECTS: {
    VIEW: 'PROJECTS_VIEW',
    ADD: 'PROJECTS_ADD',
    DELETE: 'PROJECTS_DELETE',
    UPDATE: 'PROJECTS_UPDATE',
    RESOURCE_ASSIGN: 'PROJECTS_RESOURCE_ASSIGN'
  },
  SCHEDULE: {
    VIEW: 'SCHEDULE_VIEW',
    WEEKLY: 'SCHEDULE_WEEKLY',
    MONTHLY: 'SCHEDULE_MONTHLY',
    ROTATIONAL: 'SCHEDULE_ROTATIONAL'
  },
  MOVEMENTS: {
    VIEW: 'MOVEMENTS_VIEW',
    ADD: 'MOVEMENTS_ADD'
  },
  REPORTS: {
    VIEW: 'REPORTS_VIEW',
    DAILY_ATTENDANCE: 'REPORTS_DAILY_ATTENDANCE',
    TIMESHEET: 'REPORTS_TIMESHEET',
    OVERTIME: 'REPORTS_OVERTIME',
    LATE_IN: 'REPORTS_LATE_IN',
    EARLY_OUT: 'REPORTS_EARLY_OUT',
    ABSENT: 'REPORTS_ABSENT',
    LEAVE: 'REPORTS_LEAVE'
  },
  CHECK_IN: 'CHECK_IN',
  CHECK_OUT: 'CHECK_OUT',
  BREAK_IN: 'BREAK_IN',
  BREAK_OUT: 'BREAK_OUT'
};

    